import React, { Fragment, useState,useEffect } from 'react';
import {
    Grid,
    TextField,
    FormControl,
    Button,
    Tooltip,
    Paper,
    Box,
    InputLabel,
    Select,
    MenuItem

} from '@material-ui/core';
import { useStyles } from '../../styles/style';
import axios from 'axios';
import cogoToast from 'cogo-toast';
import CancelIcon from '@material-ui/icons/Cancel';
import {content_type, radio_content_type} from '../bucket/objects'
import Switch from "react-switch";
import InfoIcon from "@material-ui/icons/InfoRounded"

const RADIO_CONTENT_TYPE_MAP = {
    "77777": "radio",
    "33": "mood-radio",
    "15": "live-radio",
    "35": "ondemand-radio",
    "36": "artist-radio",
};

export default function CreateRadio(props) {
    const classes = useStyles();
    const [name, setName] = useState("");
    const [v0, setv0] = useState([]);
    const [v1, setv1] = useState([]);
    const [v2, setv2] = useState([]);
    const [v3, setv3] = useState([]);
    const [v4, setv4] = useState([]);
    const [v5, setv5] = useState([]);
    const [v6, setv6] = useState([]);
    const [v7, setv7] = useState([]);
    const [v8, setv8] = useState([]);
    const [v9, setv9] = useState([]);
    const [v10, setv10] = useState([]);
    const [contents, setContents] = useState("");
    const [contentId, setContentId] = useState("");
    const [displayName, setDisplayName] = useState("");
    const [radioContentType, setRadioContentType] = useState("15"); // Live Radio by default
    const [lang, setLang] = useState("Default")
    const listVarient = ["v0","v1", "v2", "v3", "v4", "v5", "v6"];
    const [langList, setLangList] = useState([{ code: "Default", name: "Default" }])
    const [continueToggle, setcontinueToggle] = useState(false)
    const initialvalues = {
        contentId: "",
    }
    const handleChangeToggle = (e) =>{
        console.log('ee',e)
        setcontinueToggle(e)
    }

    const [state, setState] = useState(initialvalues)

    const handlev0 = (e) => {
        setv0([...v0, ...e.target.files])
    }
 
   

    useEffect(() => {
        fetchLanguage();
    }, [])

    const onHandleChange = (e) => {
        const value = e.target.value;
        console.log('value',value);
        setContentId(e.target.value)
        // setState({
        //     ...state,
        //     [e.target.name]: value
        // })

    }
    const onEnterContentId = (e) => {
        if (contentId !== "" && (e.key === "Enter" || e.key === "Tab")) {
            axios.get(`${process.env.REACT_APP_CMS_PLAYLIST_IP}/v1/solr/${contentId}?storeId=${localStorage.getItem("storeId")}&typeid=${radioContentType}`).then(res => {
                console.log(res.data)
                setDisplayName(res.data.data.response.docs[0].name)
            }).catch(err => {
                console.log(err)
                cogoToast.error("Wrong ContentId")
            })
        }


    }
    const postVariant = async (data) => {
        const fd = new FormData();
        fd.append("lang", data.language);
        fd.append("type", data.type);
        // fd.append("public", data.public);
        fd.append("name", data.name);
        fd.append("sectionId", data.sectionId);
        fd.append("storeId", data.storeId);
        fd.append("url", data.url);
        fd.append("vod_type", data.vod_type);
        fd.append("content_type_id", data.content_type_id);
        for (let index = 0; index < data.v0.length; index++) {
            const element = data.v0[index];
            fd.append('v0', element)
        }
        
        await axios.post(`${process.env.REACT_APP_CMS_PLAYLIST_IP}/v1/system/radio`, fd,
            { headers: { "Content-Type": "multipart/form-data" } })
            .then(res => {

                if(res.data.message == "success"){
                    cogoToast.success(res.data.message);
                   }
                   else{
                    cogoToast.error(res.data.message);
                   }
            }).catch(err => {
                cogoToast.error(err.response.data.message)
            })
    }


    const onSubmit = () => {
        const obj = {
            "type": "radio",
            "v0": v0,
            "language": lang,
            name: name,
            // public:continueToggle,
            url:contents,
            vod_type:displayName,
            "storeId":localStorage.getItem("storeId"),
            sectionId:"84",
            content_type_id: RADIO_CONTENT_TYPE_MAP[radioContentType] || "live-radio"
        }
        postVariant(obj)
        console.log(obj)
        setState(initialvalues)
        setv0([])
        setv1([])
        setv2([])
        setv3([])
        setv4([])
        setv5([])
        setv6([])
        setv7([])
        setv8([])
        setv9([])
        setv10([])
        setDisplayName("")
        setContentId("")
        setRadioContentType("15")
        setLang("Default")
        setName("")
        setcontinueToggle(false)
        setContents("")
    }

    const onClear = () => {
        setState(initialvalues)
        setv0([])
        setv1([])
        setv2([])
        setv3([])
        setv4([])
        setv5([])
        setv6([])
        setv7([])
        setv8([])
        setv9([])
        setv10([])
        setRadioContentType("15")
    }
    const deletev0 = (e, i) => {
        let newArray = v0.filter((ele, index) => {
            return index !== i;
        })

        setv0(newArray)
    }

    const fetchLanguage = async () => {
        await axios.get(`${process.env.REACT_APP_CMS_CONTENT_IP}/v1/content/type/language?storeId=${localStorage.getItem("storeId")}`).then(res => {
            setLangList([...langList, ...res.data.result.result])
            console.log('lang',res.data.result.result);
        }).catch(
            err => {
                console.log(err)
            }
        )
    }


    return (

        <Fragment>
            <Paper component={Box} p={4}>

                <div className="text-center">
                    <h1>Add Radio</h1>
                    <Grid container >
                    {/* <Grid item md={6} sm={12}>
                <FormControl variant="outlined" className={classes.formControl} >
                    <InputLabel id="demo-simple-select-outlined-label">Language</InputLabel>

                    <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={lang}
                        onChange={(e) => setLang(e.target.value)}
                        label="Language"
                    >
                        {
                            langList.length > 0 ?
                            langList.map((element, id) => {

                                    return (
                                        <MenuItem key={id} value={element.name}>{element.name}</MenuItem>
                                    )
                                }) :
                                <MenuItem disabled value="no Lamguage">No Lamguage</MenuItem>

                        }

                    </Select>

                </FormControl>
            </Grid> */}
            <Grid item md={6} sm={12}>
                            <TextField variant="outlined" className={classes.inputField} width="25" required label="Language" name="language" value={lang} onChange={(e) => setLang(e.target.value)}></TextField>
                        </Grid>
                        <Grid item md={6} sm={12}>
                            <TextField variant="outlined" className={classes.inputField} width="25" required label="Name" name="name" value={name} onChange={(e) => setName(e.target.value)}></TextField>
                        </Grid>
                        <Grid item md={6}>
                        <FormControl variant="outlined" className={classes.formControl} >
                            <InputLabel id="radio-content-type-label">Content Type</InputLabel>
                            <Select
                                labelId="radio-content-type-label"
                                id="radio-content-type"
                                value={radioContentType}
                                onChange={(e) => setRadioContentType(e.target.value)}
                                label="Content Type"
                            >
                                {
                                    radio_content_type.map((element, id) => (
                                        <MenuItem key={id} value={element.typeid}>{element.Description}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                        </Grid>
                        <Grid item md={6} sm={12}>
                            <TextField variant="outlined" className={classes.inputField} width="25" required label="Content Id" name="contentId" value={contentId} onChange={onHandleChange} onKeyDown={onEnterContentId}></TextField>
                        </Grid>
                        <Grid item md={6}>
                            <TextField variant="outlined" className={classes.inputField} width="25" required label="vod type" value={displayName} onChange={(e) => setDisplayName(e.target.value)}></TextField>
                        </Grid>
                        <Grid item md={6}>
                            <TextField variant="outlined" className={classes.inputField} width="25" required label="URL" value={contents} onChange={(e) => setContents(e.target.value)}></TextField>
                        </Grid>
                         {/* <Grid item md={6} sm={12}>
                                    Public :&nbsp;<Switch 
                                    onChange={handleChangeToggle} value={continueToggle} checked={continueToggle}
                                     />
                                        </Grid> */}
                          {/* <Grid item md={6} sm={12}>
                                      
                                      <div style={{ "display":"flex", "flex-direction":"column" }}>&nbsp;<div>Public Status :</div>&nbsp;
                                      <div><Switch 
                                      onChange={handleChangeToggle} value={continueToggle} checked={continueToggle}
                                       />
                                       </div>
                                       </div>
                                          </Grid>               */}
                       
                        <Grid item md={6} sm={12}>
                            <Button
                                className={classes.upload}
                                variant="outlined"
                                component="label"

                            >
                                v0 Thumbnail
                                <input
                                    multiple
                                    type="file"
                                    hidden
                                    onChange={handlev0}
                                    onClick={(event) => {
                                        event.target.value = null
                                    }}
                                />
                            </Button>
                            {v0.length > 0 ?
                                (v0.map((ele, i) => <p className="mt-2 mr-4">{ele.name} <CancelIcon onClick={(e) => deletev0(e, i)} /></p>))
                                : null}

                        </Grid>
                        <Grid item md={12}>
                            <Button type="submit" className="m-4" variant="contained" color="primary" onClick={onSubmit}>Submit</Button>
                            <Button variant="contained" color="secondary" onClick={onClear}>Clear</Button>

                        </Grid>
                    </Grid>
                </div>
            </Paper>


        </Fragment>
    )
}
